// Todo Check for all other errors updated
export const otherHaltReasons = [
  'ai_message_unreviewed',
  'li_inmail_error',
  'li_inmail_not_found',
  'li_inmail_forbidden',
  'li_inmail_rate_limited',
  'li_inmail_limit_reached',
  'li_connection_error',
  'li_connection_not_found',
  'li_connection_to_self',
  'li_connection_already_pending',
  'li_connection_already_connected',
  'li_connection_limit_reached',
  'li_connection_email_required',
  'li_connection_rate_limited',
  'li_connection_pending_limited',
  'li_connection_already_rejected',
  'application_in_ats_job',
  'li_inmail_retriable_error',
  'li_connection_retriable_error',
];

export const haltReasonValue = {
  replied: 'Candidate responded to a previous step',
  candidate_interested: 'Candidate was marked as interested',
  candidate_not_interested: 'Candidate was marked as not interested',
  email_not_found: 'Email not found',
  email_bounced: 'Email bounced',
  ai_message_unreviewed: 'Pending review - AI message',
  li_inmail_error: 'LinkedIn - InMail error',
  li_inmail_not_found: 'LinkedIn - Profile URL not valid',
  li_inmail_forbidden: 'Access denied - No recruiter account found',
  li_inmail_rate_limited: 'Exceeded InMail limits',
  li_inmail_limit_reached: 'InMail credits exhausted',
  li_inmail_retriable_error: 'Unexpected error',
  li_connection_error: 'LinkedIn - Connection request error',
  li_connection_not_found: 'LinkedIn - Profile URL not valid',
  li_connection_to_self: 'Connection request - Self',
  li_connection_already_pending: 'Connection request - Already pending',
  li_connection_already_connected: 'Connection request - part of your network',
  li_connection_limit_reached: 'Exceeded connection request limits',
  li_connection_email_required: 'Connection request - Email id required',
  li_connection_rate_limited: 'Exceeded connection request limits',
  li_connection_pending_limited: 'Exceeded pending connection request limits',
  li_connection_already_rejected: 'Connection request - Already rejected',
  li_connection_retriable_error: 'Unexpected error',
};
